module.exports = __webpack_public_path__ + "static/media/box-ballot.3d54fcfd.svg";